angular.module("app").controller("ProvidersAddPageController", [
    '$scope',
    'preloadedData',
    'pageStatuses',
    'casinoProviderService',
    'errorHandler',
    'logger',
    '$stateParams',
    function ($scope, preloadedData, pageStatuses, casinoProviderService, errorHandler, logger, $stateParams) {


        $scope.tooltip = {
            name: "",
            title: ""
        };

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
            casinoProviderService.create({casinoProvider: $scope.providerData}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        init();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isForItem = function () {
            return !isNaN(+$stateParams.itemId)
        };

        function init() {
            $scope.providerData = {
                name: "",
                title: "",
                status: pageStatuses[0]
            };

            $scope.add_providers_form && $scope.add_providers_form.$setPristine();
        }

        init();

        
    }
]);